export const data = [
  {
    id: "ETH",
    value: 25,
  },
  {
    id: "ADA",
    value: 15,
  },
  {
    id: "others",
    value: 5,
  },
  {
    id: "btc",
    value: 55,
  },
];
